export const isLoependeVedtakEndring = (loependeVedtak: LoependeVedtak) => {
  return !!loependeVedtak.alderspensjon
}
